import { List as AntdList } from 'antd';
import styled from 'styled-components';
import { Text01 } from 'components/styles';

const ListItem = styled(AntdList.Item)``;

const ListComponent = styled(AntdList)`
  ${ListItem} {
    border: 0;
    padding: 0;

    .ant-space {
      width: 100%;

      &-item {
        ${Text01};
        white-space: nowrap;
        max-width: 75%;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    > a {
      align-items: center;
      display: flex;
      height: var(--height-lg);
      padding: var(--spacing-03) var(--spacing-04);
      width: 100%;

      &:hover {
        background: var(--item-hover-bg);
      }
    }
  }
`;

type List = typeof AntdList;

const ListWithLink: List = ListComponent as any;

ListWithLink.Item = ListItem;

export { ListWithLink };
